import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Card, Button, Spin, Space, Tag, message } from 'antd';
import { LinkOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import AppLayout from '../components/common/Layout';
import FormResponseView from '../components/form/FormResponseView';
import { reportApi } from '../api/reportApi';
import { formatDate } from '../utils/dateHelpers';
import { FORM_STATUS_LABELS, FORM_STATUS_COLORS } from '../utils/validation';

const { Title, Text } = Typography;

const ReportDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const response = await reportApi.getById(id);
        setReport(response.data.report);
      } catch {
        setReport(null);
      } finally {
        setLoading(false);
      }
    };
    fetchReport();
  }, [id]);

  if (loading) {
    return (
      <AppLayout>
        <div style={{ textAlign: 'center', padding: 48 }}>
          <Spin size="large" />
        </div>
      </AppLayout>
    );
  }

  if (!report) {
    return (
      <AppLayout>
        <Card>Отчёт не найден</Card>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <Button type="link" icon={<ArrowLeftOutlined />} onClick={() => navigate('/reports')} style={{ paddingLeft: 0 }}>
        К списку отчётов
      </Button>

      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <Title level={3}>
            Отчёт: {report.teamMemberId?.fullName}
          </Title>
          <Space>
            <Tag color={FORM_STATUS_COLORS[report.status]}>{FORM_STATUS_LABELS[report.status]}</Tag>
            <Text type="secondary">Срок до {formatDate(report.expiresAt)}</Text>
            {report.submittedAt && (
              <Text type="secondary">· Заполнен {formatDate(report.submittedAt)}</Text>
            )}
          </Space>
        </div>
        <Space>
          {report.fillUrl && report.status !== 'expired' && report.status !== 'discussed' && (
            <Button
              icon={<LinkOutlined />}
              onClick={() => {
                navigator.clipboard.writeText(report.fillUrl);
                message.success('Ссылка скопирована');
              }}
            >
              Копировать ссылку
            </Button>
          )}
          {report.status === 'submitted' && (
            <Button type="primary" onClick={() => navigate(`/meetings/new?reportId=${report._id}`)}>
              Обсудить
            </Button>
          )}
        </Space>
      </div>

      <Card title="Ответы сотрудника">
        {report.status === 'pending' ? (
          <Text type="secondary">Отчёт ещё не заполнен. Отправьте ссылку сотруднику.</Text>
        ) : (
          <FormResponseView form={report} />
        )}
      </Card>
    </AppLayout>
  );
};

export default ReportDetail;
